import { Card, Grid, IconButton } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AddJobCommand, Client, Product } from '../../../../api/models/schema';
import { JobGrid } from './jobGrid';
import { BasicButton } from '../../../../common/basicButton';
import RefreshIcon from "@mui/icons-material/Refresh";
import { EditJobForm } from './editJobForm';
import { ClientContext } from '../../../../context/clientContext';
import { JobFormContext } from '../../../../context/jobFormContext';


export interface ClientTabProps {
    onAdd: (jobCommand:AddJobCommand) => void,
    onRefresh: () => void
}

export default function ClientJobTab(props: ClientTabProps) {

    const { client } = useContext(ClientContext);
    const jobFormCtxt = useContext(JobFormContext);

    function handleAddJob(jobCommand:AddJobCommand) : void {
        props.onAdd(jobCommand);
        setTimeout(refreshPage, 5000);
    }

    function refreshPage() {
        props.onRefresh();
    }


    return (
        <Card
        style={{
          margin: 5,
          padding: 15,
          border: "1px solid #cecece",
          borderRadius: 10,
          backgroundColor: "#f2f2f2",
          textDecoration: "none",
        }}
      >
        {/* <h2>Jobs</h2> */}
        <Grid container>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
            item
            xs={12}
          >
            <BasicButton
              onClick={jobFormCtxt.openForm}
              labelText="Add Job"
            />
            {client?.jobs && (
              <IconButton onClick={refreshPage}>
                <RefreshIcon />
              </IconButton>
            )}
          </Grid>

          <Grid item xs={12}>
            <br />
            {client?.jobs && (
              <>
                <JobGrid jobs={client?.jobs}/>
              </>
            )}

            <EditJobForm products={client?.products ?? []} 
                              isLoading={jobFormCtxt.isLoading}
                                  open={jobFormCtxt.showForm} 
                                  onClose={jobFormCtxt.closeForm}
                                  errorMessage={jobFormCtxt.errorMessage}
                                  onUpdate={handleAddJob} />

          </Grid>
        </Grid>
      </Card>
    )
}